import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  text-align: center;
  padding: 20px;
  margin: 0 auto;
  overflow: auto;
  @media only screen and (max-width: 500px) {
    padding-top: 60px;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
`;

export const ExportContainer = styled.div`
  display: flex;
  flex: 1;
  padding-top: 20px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Header = styled.div`
  display: flex;
  padding: 20px;
  justify-content: space-between;
  align-items: center;
`;

export const Main = styled.div`
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #d3d3d3;
  width: 100%;
`;

export const Footer = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  padding: 10px;
`;

export const Title = styled.h1`
  text-align: left;
  color: #0083ff;
  font-size: 18px;
  width: 200px;
`;

export const Button = styled.button`
  background: ${props => (props.submit ? '#0083ff' : '#FF8800')};
  color: white;
  cursor: pointer;
  font-size: 14px;
  border-radius: 4px;
  border: none;
  height: 30px;
  padding: 0 20px;
`;

export const ExportButton = styled.button`
  background: #1ea630;
  color: white;
  cursor: pointer;
  font-size: 16px;
  border-radius: 4px;
  border: none;
  height: 40px;
  width: 200px;
  padding: 0 20px;
`;

export const ExportButtonContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
`;

export const inputFilter = styled.style`
  width: 200px;
`;
